/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Meal_Breakfast_DishInputs */

const en_for_whom_meal_breakfast_dish = /** @type {(inputs: For_Whom_Meal_Breakfast_DishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oats with fruit and skyr`)
};

const pl_for_whom_meal_breakfast_dish = /** @type {(inputs: For_Whom_Meal_Breakfast_DishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Owsianka z owocami i skyrem`)
};

/**
* | output |
* | --- |
* | "Oats with fruit and skyr" |
*
* @param {For_Whom_Meal_Breakfast_DishInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_meal_breakfast_dish = /** @type {((inputs?: For_Whom_Meal_Breakfast_DishInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Meal_Breakfast_DishInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_meal_breakfast_dish(inputs)
	return en_for_whom_meal_breakfast_dish(inputs)
});